var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfinity = function SvgInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 66 66"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Infinity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h66v66H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Infinity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M33 31.62c5.5-8.26 11-12.37 16.5-12.37 3.03 0 5.63 1.2 7.77 3.62 2.15 2.42 3.23 5.33 3.23 8.75s-1.08 6.33-3.23 8.75C55.13 42.79 52.53 44 49.5 44c-5.5 0-11-4.12-16.5-12.38S22 19.25 16.5 19.25c-3.04 0-5.64 1.2-7.78 3.62-2.15 2.42-3.22 5.33-3.22 8.75s1.07 6.33 3.22 8.75C10.86 42.79 13.46 44 16.5 44c5.5 0 11-4.12 16.5-12.38Z"
  }))));
};
export default SvgInfinity;